import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTickIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 8,
	viewBox: "0 0 10 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 3.99992L3.58 6.82992L9.25 1.16992",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTickIcon;
